(function($) {

	function marketsInit() {

		var $marketsFilter = $('.jq-markets-filter');

		if ($marketsFilter.length) {

			$marketsFilter.each(function() {

				var $marketFilter = $(this);

				if ($marketFilter.hasClass('is-loaded')) return;

				$marketFilter.addClass('is-loaded');

				$marketFilter
					.find(':input')
					.on('change', function() {
						$marketFilter.submit();
					});

				$marketFilter
					.on('submit', function(event) {
						event.preventDefault();

						if ($().ajaxify) {
							marketsReload($marketFilter, event);
						} else {
							$.getScript(siteConfig.shared + 'jquery.ajaxify.js', function() {
								marketsReload($marketFilter, event);
							});
						}
					});

			});

		}

		// TO-DO: init navigation buttons of gallery scrollbar

		var $marketsMap = $('.jq-markets-map');

		if ($marketsMap.length) {

			var marketsMapObserver = new IntersectionObserver(function(entries, observer) {
				$.each(entries, function(entryKey, entry) {
					if (entry.isIntersecting) {
						var $marketMap = $(entry.target);

						if (typeof google === 'object' && google && 'maps' in google){
							marketsMap($marketMap);
						} else {
							$marketMap.addClass('is-in-view');

							$.getScript('//maps.googleapis.com/maps/api/js?key=' + siteConfig.gmapKey + '&callback=marketsMap');
						}

						observer.unobserve(entry.target);
					}
				});
			});

			$('.jq-markets-map').each(function() {
				marketsMapObserver.observe(this);
			});

		}

	};

	function marketsReload($marketFilter, event) {
		var ajaxRequest = $marketFilter.serialize();

		if ('originalEvent' in event && 'submitter' in event.originalEvent) {
			ajaxRequest += '&' + event.originalEvent.submitter.getAttribute('name') + '=true';
		}

		$.ajaxLink(
			window.location.href,
			{
				history: false,
				refresh: [ '#' + $marketFilter.parents('.jq-markets').attr('id') ],
				onFinish: marketsInit
			},
			document.body,
			'GET',
			ajaxRequest
		);
	};

	function marketsMap($marketMap) {

		if (typeof $marketMap == 'undefined' || $marketMap == '') {

			$marketMap = $('.jq-markets-map.is-in-view');

			$marketMap.removeClass('is-in-view');

		}

		if ($marketMap.hasClass('is-loaded')) return;

		$marketMap.addClass('is-loaded');

		var $markets = $marketMap.parents('.jq-markets');

		var marketMapOptions = $marketMap.data('map-options') || '';

		if (marketMapOptions == '') return;

		marketMapOptions.zoomControlOptions = {
			position: google.maps.ControlPosition.RIGHT_CENTER,
		};

		var marketMap = new google.maps.Map($marketMap[0], marketMapOptions);

		var marketMarkers = [];

		$markets.find('.jq-markets-marker').each(function() {

			var $marketsMarker = $(this);

			if (typeof $marketsMarker.data('marker-position') == 'undefined') return;

			var marketMarkerOptions = {
				position: $marketsMarker.data('marker-position'),
				map: marketMap,
			};

			var marketMarkerContent = $marketsMarker.html();

			var marketMarkerIcon = $marketsMarker.is(':hidden') && marketMapOptions.region ? 2 : 0;

			if ('icons' in marketMapOptions && marketMapOptions.icons[marketMarkerIcon]) {
				marketMarkerOptions.icon = marketMapOptions.icons[marketMarkerIcon];
			}

			var marketMarker = {
				pin: new google.maps.Marker(marketMarkerOptions),
				icon: marketMarkerIcon,
			};

			if (marketMarkerContent != '') {
				marketMarker.window = new google.maps.InfoWindow({
					content: '<div class="' + ($marketsMarker.data('marker-class') || '') + '">' + marketMarkerContent + '</div>',
				});
			}

			marketMarkers.push(marketMarker);

			/*$marketsMarker.css('cursor', 'pointer');

			$marketsMarker.on('click', function() {
				marketMarkerOpen(marketMarker);
			});*/

		});

		marketMarkers.forEach(function(marketMarker) {

			if ('window' in marketMarker) {

				marketMarker.pin.addListener('click', function() {
					marketMarkerOpen(marketMarker, true);
				});

				// TO-DO: on window open init navigation buttons of gallery scrollbar


				marketMarker.window.addListener('closeclick', function() {
					marketMarkerChangeIcon(marketMarker, marketMarker.icon);
				});

			}

		});

		function marketMarkerOpen(marketMarker, enableScrollMarket) {
			enableScrollMarket = enableScrollMarket || false;

			if (typeof marketMarkerActive !== 'undefined') {
				marketMarkerActive.window.close();

				marketMarkerChangeIcon(marketMarkerActive, marketMarkerActive.icon);
			}

			if (marketMarker.window.content.indexOf('data-src') !== -1) {

				marketMarker.window.setContent(
					marketMarker.window.content.replace('data-src', 'src')
				);

			}

			marketMarker.window.open({
				anchor: marketMarker.pin,
				map: marketMap,
				shouldFocus: false,
			});

			marketMarkerChangeIcon(marketMarker, 1);

			marketMarkerActive = marketMarker;

			if (enableScrollMarket) {
				// scroll to market in list
			}
		}

		function marketMarkerChangeIcon(marketMarker, icon) {
			if ('icons' in marketMapOptions && marketMapOptions.icons[icon]) {
				marketMarker.pin.setIcon(marketMapOptions.icons[icon]);
			}
		};

	};

	window.marketsMap = marketsMap;

	marketsInit();

})(jQuery);
